import { Link } from "react-router-dom";
import { LEGAL_INFO } from "../pages/LegalPage";

export const LEGAL_LINE = `Casanéo by ${LEGAL_INFO.editor} · SAS ${LEGAL_INFO.editor} · SIREN 941 435 919 · RCS Nice · 50 bd Stalingrad, 06300 Nice`;
export const NON_AFFILIATION = "Casanéo (casaneo.pro) est un logiciel de conciergerie édité par SAS MHP Immobilier, Nice. Il n'a aucun lien avec la société Casaneo (casaneo.io), plateforme d'affiliation marketing.";

export function LegalFooterLinks({ className = "" }) {
  return (
    <div className={`text-[11px] text-muted-foreground/80 text-center space-y-1 ${className}`} data-testid="legal-footer">
      <p data-testid="legal-footer-identity">{LEGAL_LINE}</p>
      <p className="flex flex-wrap justify-center gap-x-3 gap-y-1">
        <Link to="/mentions-legales" className="hover:underline" data-testid="legal-footer-mentions">Mentions légales</Link>
        <Link to="/cgv" className="hover:underline" data-testid="legal-footer-cgv">CGU / CGV</Link>
        <Link to="/confidentialite" className="hover:underline" data-testid="legal-footer-privacy">Confidentialité (RGPD)</Link>
      </p>
    </div>
  );
}
